import { render, staticRenderFns } from "./importRoomFee.vue?vue&type=template&id=3389a0aa&scoped=true"
import script from "./importRoomFee.vue?vue&type=script&lang=js"
export * from "./importRoomFee.vue?vue&type=script&lang=js"
import style0 from "./importRoomFee.vue?vue&type=style&index=0&id=3389a0aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3389a0aa",
  null
  
)

export default component.exports